import { useQuery } from '@tanstack/react-query';
import { WalletInvestmentCategory } from '../../interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';

const getWalletInvestiments = async () => {
  const { data } = await api.get<WalletInvestmentsResponse>(
    apiConfig.routes.wallet.investments
  );
  return data;
};

export const useGetWalletInvestiments = () => {
  return useQuery({
    queryKey: ['wallet', 'investments'],
    queryFn: getWalletInvestiments,
  });
};

type WalletInvestmentsResponse = {
  categories: WalletInvestmentCategoryType[];
  strategies: WalletInvestmentCategoryType[];
  subcategories: WalletInvestmentCategoryType[];
};

export type WalletInvestmentCategoryType = Omit<
  WalletInvestmentCategory,
  'investments'
>;
